import styled from 'styled-components';

import { StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

export const PairInfoContainer = styled(StyledFlexContainer)`
    & span {
        min-width: 100%;
    }
    &:nth-child(1) {
        overflow-x: hidden;
    }
`;

export const PairName = styled(StyledFlexContainer)`
    ${({ theme: { colors, typography } }) => `
        & > div {
            color: ${colors.text.tertiary};
            & > div {
                &:nth-of-type(1) {
                    min-width: max-content;
                    display: flex;
                    flex-direction: column;
                    & > span {
                        &:nth-child(1) {
                            line-height: ${typography.lineHeight[6]};
                        }
                        & > :nth-child(1) {
                            color: ${colors.text.primary};
                        }
                    }
                }
                &.label {
                    font-size: ${typography.size.desktop.paragraph.p3};
                    line-height: ${typography.lineHeight[2]};
                    font-weight: ${typography.weight.medium};
                    border: 1px solid ${colors.primary};
                    overflow: hidden;
                    border-radius: 2px;
                    display: flex;
                    align-items: center;
                    margin-left: 4px;
                    padding: 0 2px;
                    text-align: center;
                }
            }
            & > svg {
                margin: 0 6px;
            }
        }
        & > span {
            min-width: auto;
            display: flex;
            align-items: center;
            & > svg:nth-of-type(1) {
                width: 14px;
                height: 14px;
            }
        }
        & .tippy-box.tooltip.coin-info-tooltip {
            max-width: 560px !important;
            border-radius: 6px;
            & > .tippy-content {
                padding: 0;
            }
        }
    `};
`;

export const Bar = styled.div<{ height: string; margin: string }>`
    ${({ theme: { colors }, height, margin }) => `
        border: 1px solid ${colors.border.light};
        height: ${height};
        margin: ${margin};
    `}
`;

export const PairInfoModuleWrapper = styled(StyledFlexContainer)`
    ${({ theme: { breakpoints } }) => `
        @media (max-width: ${breakpoints.lg}) {
            overflow-x: scroll;
            margin-right: 24px;
            -ms-overflow-style: none;
            scrollbar-width: none;
            &::-webkit-scrollbar {
                display: none;
            }
        }
    `}
`;

export const ThemeSwitchWrapper = styled(StyledFlexContainer)`
    ${({ theme: { breakpoints } }) => `
        @media (max-width: ${breakpoints.lg}) {
            padding-right: 24px;
        }
    `}
`;

export const PairInfoModule = styled(StyledFlexContainer)`
    flex-direction: column;
    min-width: max-content;
    ${({ theme: { typography, colors } }) => `
        &.heading {
            font-size: ${typography.size.desktop.heading.h6};
            line-height: calc(${typography.lineHeight[7]} - 1px);
            font-weight: ${typography.weight.medium};
            letter-spacing: -0.03em;
        }
        & > span {
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            &:nth-of-type(1) {
                color: ${colors.text.tertiary};
                margin-bottom: 4px;
                &.funding-rate {
                    & span {
                        cursor: pointer;
                    }
                }
            }
            &:nth-of-type(2) {
                color: ${colors.text.primary};
            }
        }
        &:not(:last-of-type) {
            margin-right: 24px;
        }
    `}
`;

export const CoinInfoTooltip = styled.div`
    ${({ theme: { colors, typography, breakpoints } }) => `
        @media (min-width: ${breakpoints.md}) {
            width: 560px;
            height: 349px;
            overflow-y: auto;
            padding: 16px 24px;
        }
        & > span {
            color: ${colors.text.primary};
            font-size: ${typography.size.desktop.paragraph.p2};
            line-height: ${typography.lineHeight[5]};
            font-weight: ${typography.weight.medium};
            @media (max-width: ${breakpoints.md}) {
                line-height: ${typography.lineHeight[6]};
                font-weight: ${typography.weight.semiBold};
            }
        }
        & > div {
            justify-content: space-between;
            flex-direction: column;
            width: 100%;
            margin-top: 16px;
            & > div {
                width: 100%;
                &:not(:last-of-type) {
                    margin-bottom: 16px;
                }
                &:nth-of-type(1) {
                    font-size: ${typography.size.desktop.paragraph.p1};
                    line-height: ${typography.lineHeight[6]};
                    & > img {
                        width: 24px;
                        height: 24px;
                        margin-right: 15px;
                    }
                    & > span {
                        color: ${colors.text.tertiary};
                        min-width: auto;
                    }
                }
                &:nth-of-type(2) {
                    justify-content: space-between;
                    font-size: ${typography.size.desktop.paragraph.p2};
                    line-height: ${typography.lineHeight[5]};
                    & > div {
                        flex-direction: column;
                        gap: 8px;
                    }
                    & > div {
                        &:nth-of-type(1) {
                            color: ${colors.text.tertiary};
                        }
                        &:nth-of-type(2) {
                            word-break: break-all;
                            line-height: ${typography.lineHeight[4]};
                            letter-spacing: 0.02em;
                            text-align: end;
                            & a, a:hover {
                                color: ${colors.text.primary};
                                text-decoration: underline;
                            }
                        }
                        @media (max-width: ${breakpoints.md}) {
                            &:nth-of-type(1) {
                                font-size: ${typography.size.desktop.paragraph.p3};
                                line-height: ${typography.lineHeight[4]};
                            }
                            &:nth-of-type(2) {
                                font-size: ${typography.size.desktop.paragraph.p2};
                                line-height: ${typography.lineHeight[4]};
                            }
                        }
                    }
                }
                &:nth-of-type(3) {
                    flex-direction: column;
                    gap: 8px;
                    & > span {
                        width: 100%;
                        font-size: ${typography.size.desktop.paragraph.p2};
                        line-height: ${typography.lineHeight[5]};
                        font-weight: ${typography.weight.medium};
                    }
                    & > div {
                        width: 100%;
                        font-size: ${typography.size.desktop.paragraph.p2};
                        line-height: ${typography.lineHeight[4]};
                        color: ${colors.text.tertiary};
                        word-wrap: break-word;
                        letter-spacing: 0.02em;
                    }
                    @media (max-width: ${breakpoints.md}) {
                        & > span {
                            line-height: ${typography.lineHeight[6]};
                            font-weight: ${typography.weight.semiBold};
                        }
                        & > div {
                            line-height: ${typography.lineHeight[6]};
                            color: ${colors.text.primary};
                        }
                    }
                }
                &:nth-of-type(4) {
                    & > a {
                        font-size: ${typography.size.desktop.paragraph.p3};
                        line-height: calc(${typography.lineHeight[2]} - 1px);
                    }
                }
            }
        }
    `}
`;
